import { render, staticRenderFns } from "./sellerdetails.vue?vue&type=template&id=75ccfa42&scoped=true"
import script from "./sellerdetails.vue?vue&type=script&lang=js"
export * from "./sellerdetails.vue?vue&type=script&lang=js"
import style0 from "./sellerdetails.vue?vue&type=style&index=0&id=75ccfa42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ccfa42",
  null
  
)

export default component.exports